var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"riseup-icon-item"},[_c('icon',{style:(_vm.iconStyles),attrs:{"name":_vm.iconName,"icon-name":_vm.iconFontName,"size":_vm.iconSize,"color":_vm.iconColor,"fill":_vm.fillIcon}}),_vm._v(" "),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):(_vm.hasTextSlot)?_c('div',[_vm._t("text")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }